import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';

export default class Cheque extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			status: props.Status,
			data: null,
			loading: true,
			returnDescription: '',
			tafsilAccountId: null,
			date: null,
			vosolType: 1
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/cheque/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.setState({
						data: data,
						loading: false
					});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save() {
		this.httpPost("api/v1/cheque/change", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			status: this.state.status,
			returnDescription: this.state.returnDescription,
			date: this.convertMomentToDb(this.state.date),
			tafsilAccountId: this.state.tafsilAccountId,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setTafsil(e) {
		this.state.tafsilAccountId = e.value;
	}
	renderForm() {
		return <div className="modal fade in show" tabindex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" className="close" onClick={e => this.closeMe()} ><span aria-hidden="true">×</span></button>
						<h4 className="modal-title" id="chequeReturnModalLabel">
							{this.state.status === 2 && <span>واگذاری</span>}
							{this.state.status === 3 && <span>وصول چک</span>}
							{this.state.status === 4 && <span>برگشت چک</span>}
							{this.state.status === 5 && <span>عودت چک</span>}
							{this.state.status === 6 && <span>سرحساب</span>}
							{this.state.status === 7 && <span>پاس چک</span>}
						</h4>
					</div>
					<div className="modal-body">
						<div className="container-fluid">
							{2 === 1 && this.state.status === 3 && <div className="row">
								<div className="col-sm-3 text-left">نحوه دریافت :</div>
								<div className="col-sm-9">
									<div className="btn-group" role="group" aria-label="...">
										<button onClick={this.setState({ vosolType: 1, tafsilCode: null, accountTafsilType: -1 })} type="button" className={"btn btn-primary btn-sm" + (this.state.vosolType === 1 ? " btn-primary" : "")}>نقدی</button>
										<button onClick={this.setState({ vosolType: 2, tafsilCode: null, accountTafsilType: -1 })} type="button" className={"btn btn-primary btn-sm" + (this.state.vosolType === 2 ? " btn-primary" : "")}>بانک</button>
									</div>
								</div>
							</div>}
							{this.state.status === 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">شخص <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب شخص"
										defaultOptions
										loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 1)}
										onChange={e => this.setTafsil(e)}
									/>
								</div>
							</div>}
							{this.state.status === 7 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">بانک <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب بانک"
										defaultOptions
										loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 3)}
										onChange={e => this.setTafsil(e)}
									/>
								</div>
							</div>}
							{this.state.status === 3 && this.state.vosolType == 1 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">بانک <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب بانک"
										defaultOptions
										loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 3)}
										onChange={e => this.setTafsil(e)}
									/>
								</div>
							</div>}
							{this.state.status === 3 && this.state.vosolType == 2 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">صندوق <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<SelectAsync
										isMulti={false}
										placeholder="انتخاب صندوق"
										defaultOptions
										loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 4)}
										onChange={e => this.setTafsil(e)}
									/>
								</div>
							</div>}
							{this.state.status === 5 && <div className="row mr-t-5">
								<div className="col-sm-3 text-left">علت عودت <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<input defaultValue={this.state.returnDescription} onChange={e => this.state.returnDescription = e.target.value} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
								</div>
							</div>}
							<div className="row mr-t-5">
								<div className="col-sm-3  text-left">تاریخ <span className="red">*</span> :</div>
								<div className="col-sm-9">
									<DatePicker
										inputReadOnly={true}
										className="form-control input-sm persian-date"
										placeholder={"تاریخ"}
										isGregorian={false}
										showTodayButton={true}
										timePicker={false}
										onChange={(e) => { this.state.date = e }}
										value={this.getFormatedDateForDatePicker(this.state.date)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
						<button onClick={e => this.save()} className="btn btn-success">ذخیره </button>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.renderForm()
			];

		return contents;
	}
}